import dayjs, { Dayjs } from "dayjs";
import { ReactNode } from "react";
import { classNames } from "../UI/Utils/classNames.ts";

export function CalendarDayLabel({
  slotCount,
  day,
  daySubtitle,
}: {
  slotCount: number;
  day: Dayjs;
  daySubtitle?: ReactNode;
}) {
  const isToday = day.isSame(dayjs(), "day");

  function getCalendarTitleClass(): string {
    if (isToday) return "bg-primary text-white";
    if (slotCount <= 0)
      return "border border-slate-400 text-black text-slate-400";
    return "border border-slate-400 bg-slate-200 text-black";
  }

  return (
    <div
      key={day.valueOf()}
      className={classNames(
        "px-2 font-bold md:font-normal md:py-6 py-2 items-center justify-center space-x-2 md:space-x-0 rounded-2xl text-center flex md:flex-col",
        getCalendarTitleClass(),
      )}
    >
      <span className={"text-sm md:font-light"}>
        {day.locale("en").format("dddd")}
      </span>
      <span className={"md:text-3xl md:font-bold"}>
        {day.locale("en").format("DD")}
      </span>
      {daySubtitle && (
        <span className={"text-xs font-normal mt-0.5 opacity-75"}>
          {daySubtitle}
        </span>
      )}
    </div>
  );
}
